var map = {
	"./ark/translations/en/translation.json": 5161,
	"./bridge_positive/translations/en/translation.json": 3996,
	"./criptokuantica/translations/en/translation.json": 756,
	"./deptoken/translations/en/translation.json": 4359,
	"./domum/translations/en/translation.json": 5011,
	"./fuegos/translations/en/translation.json": 486,
	"./horizonte/translations/en/translation.json": 2849,
	"./impozo/translations/en/translation.json": 6197,
	"./muskuy/translations/en/translation.json": 423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9036;